import { createFileRoute } from '@tanstack/react-router';
import { MfaEmailSwitch } from '../../components/me/MfaEmailSwitch';

export const Route = createFileRoute('/_authenticated/_layout/me/security/mfa-email-setup')({
    component: () => <MfaEmailSwitch />,
});
